define((require) => {
    "use strict";

    const Matrix = require("shared/vendor/Matrix");


    /**
     * A Transformable is an abstract class that defines a element can be transformed
     * @constructor
     */
    function Transformable() {
        this.matrix = new Matrix();
        this.startMatrix = new Matrix();
        this.endMatrix = new Matrix();
    }

    Transformable.prototype = {

        draw() {},

        getControlsConf() {},

        getWidth() {},

        getHeight() {},

        getMatrix() {},

        setTransparency() {},

        getCornerCoordinates() {
            const m = this.matrix;
            return [
                {x: m.x, y: m.y},
                m.getGlobalCoordByLocalCoord(this.width, 0),
                m.getGlobalCoordByLocalCoord(this.width, this.height),
                m.getGlobalCoordByLocalCoord(0, this.height)
            ];
        },

        transform(preMatrix, postMatrix, regU, regV) {
            // apply transforms (pre, post)
            this.endMatrix.identity();
            this.endMatrix.concat(preMatrix);
            this.endMatrix.concat(this.startMatrix);

            // next, the post transform is concatenated on top
            // of the previous result, but for the post transform,
            // translation (x,y) values are not transformed. They're
            // saved with the respective post transform offset, then
            // reassigned after concatenating the post transformation
            let x = this.endMatrix.x + postMatrix.x;
            let y = this.endMatrix.y + postMatrix.y;

            // finally, concatenate post transform on to final
            this.endMatrix.concat(postMatrix);

            // reassign saved tx and ty values with the
            // included registration offset
            this.endMatrix.x = x;
            this.endMatrix.y = y;

            if (regU !== 0 || regV !== 0) {
                // registration offset
                // local registration location
                x = regU * this.width;
                y = regV * this.height;
                // delta transform by start matrix
                let rx = this.startMatrix.a * x + this.startMatrix.c * y;
                let ry = this.startMatrix.d * y + this.startMatrix.b * x;
                // subtract delta transform end matrix
                rx -= this.endMatrix.a * x + this.endMatrix.c * y;
                ry -= this.endMatrix.d * y + this.endMatrix.b * x;
                // shift by remaining
                this.endMatrix.translate(rx, ry);
            }

            this.matrix.copyFrom(this.endMatrix);
            this.draw();
        },

        translate(x, y) {
            this.matrix.x += x;
            this.matrix.y += y;
            this.draw();
        },

        isTransformed() {
            return !this.startMatrix.equals(this.matrix);
        },

        /**
         * This is to cope with that objects may be transformed outside FreeTransform
         * so we need to update the width, height and matrix whenever we start transforming
         */
        updateFromTarget() {
            this.width = this.getWidth();
            this.height = this.getHeight();
            this.matrix = this.getMatrix();
        },

        commit() {
            this.startMatrix.copyFrom(this.matrix);
            this.sanitizeStartMatrix();
        },

        sanitizeStartMatrix() {
            if (this.startMatrix.a === 0 && this.startMatrix.b === 0) {
                this.startMatrix.a = 1 / this.getWidth();
            }

            if (this.startMatrix.d === 0 && this.startMatrix.c === 0) {
                this.startMatrix.d = 1 / this.getHeight();
            }
        }
    };

    return Transformable;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/transformations/Transformable.js